<app-step-challenge-form
  [initialValue]="challenge()"
  [isReadOnly]="isReadOnly()"
  [isSaving]="isSaving()"
[goBackNavigate]="goBackNavigate"
  (save)="onSave($event)"
  (editRequested)="onEditRequested()"
  (back)="goBack()"
></app-step-challenge-form>

<app-save-changes-confirmation
  [navigate]="goBackNavigate"
  data-test-id="step-challenges-save-changes-confirmation"
></app-save-changes-confirmation>
